import messages from '../../messages.json';

export const commonMessage = {
  emailError: messages.common.error.email,
  emailMaxLimitError: (limit: number) =>
    messages.common.error.emailMaxLimit.replace('{{limit}}', String(limit)),
  licenseError: messages.common.error.chooseLicense,
  phoneNumberError: messages.common.error.invalidPhoneNumber,
  requiredField: (fieldName: string) =>
    messages.common.error.requiredField.replace('{{fieldName}}', fieldName),
  lengthError: (length: number) =>
    messages.common.error.length.replace('{{length}}', String(length)),
  lengthValidationError: (fieldName: string, length: number) =>
    messages.common.error.lengthValidation
      .replace('{{fieldName}}', fieldName)
      .replace('{{length}}', String(length)),
  quantityError: (min: number, max: number) =>
    messages.common.error.quantity
      .replace('{{min}}', String(min))
      .replace('{{max}}', String(max)),
};

export const organizationMessage = {
  idError: messages.common.error.org.idError,
  emailError: messages.common.error.org.emailError,
  dateError: messages.common.error.org.dateError,
};
